import React, { useEffect, useState } from 'react'
import { Form, Formik } from 'formik'
import {injectIntl} from "react-intl";
import {
  Button,
  Container,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
} from '@material-ui/core'
import { Visibility, VisibilityOff } from "@material-ui/icons"
import { withStyles } from '@material-ui/core/styles'
import axios from "axios";
import clsx from 'clsx'
import moment from 'moment';

import messages from "./messages";
import styles from './styles'
import docCookies from "../../docCookies";
import {history} from "../../history";
import PopupModal from "../../common/elements/PopupModal";

const initialValues = {
  password: '',
  repeatPassword: '',
}
const COOKIE_EXPIRY_TIME =  moment().add('days', 7).toDate() // one week

const CreatePasswordForm = props => {
  const {
    classes,
    intl: { formatMessage },
    match,
    setFormToDisplay,
  } = props
  const { params } = match
  const [passwordVisibility1, setPasswordVisibility1] = useState(false)
  const [passwordVisibility2, setPasswordVisibility2] = useState(false)
  const [passwordTooShort, setPasswordTooShort] = useState(false)
  const [passwordsDoNotMatch, setPasswordsDoNotMatch] = useState(false)
  const [username, setUsername] = useState('')
  const [modalMessage, setModalMessage] = useState('')
  const [uid] = useState(params.uid)
  const [token] = useState(params.token)

  useEffect(() => {
    const postData = { token, uid }

    axios.post('/api-auth/password/reset/verify/',  postData )
      .then(({ data }) => {
        setUsername(data.username)
      })
      .catch(() => setModalMessage(formatMessage(messages.incorrectUrlMessage)))
  }, [formatMessage, token, uid])

  const createNewPassword = values => {
    const { password, repeatPassword } = values
    let authToken
    const params = {
      new_password1: password,
      new_password2: repeatPassword,
      uid,
      token,
    }
    axios.post('/api-auth/password/reset/confirm/', params )
      .then(() => {
        axios.post('/api/v2/authenticate', { username, password })
          .then(({ data }) => {
            authToken = `JWT ${data.auth_token}`
            const requestConfig = {
              headers: { 'Authorization': authToken },
            }
            return axios.get('/api/v3/identity', requestConfig)
          })
          .then(({ data }) => {
            if (data.roles.business_admin) {
              docCookies.setItem('jwt', authToken, COOKIE_EXPIRY_TIME )
              docCookies.setItem('username', username, COOKIE_EXPIRY_TIME)
              docCookies.setItem('user_id', data.roles.staff.staff_id, COOKIE_EXPIRY_TIME)
              setModalMessage(formatMessage(messages.resetPasswordComplete))
            } else setModalMessage(formatMessage(messages.couldNotResetPassword))
        })
      })
      .catch(() => setModalMessage(formatMessage(messages.couldNotResetPassword)))
  }

  const checkPasswordLength = values => {
    const { password } = values
    if (password.length < 8) setPasswordTooShort(true)
  }

  const checkPasswordsMatch = values => {
    const { password, repeatPassword } = values
    if (password !== repeatPassword) setPasswordsDoNotMatch(true)
  }

  const redirectToCorrectPage = () => {
    if (modalMessage === formatMessage(messages.couldNotResetPassword)) setModalMessage('')
    else if (modalMessage === formatMessage(messages.resetPasswordComplete)) history.push('/home')
    else {
      setModalMessage('')
      setFormToDisplay('login')
      history.push('/login')
    }
  }

  return (
    <Formik initialValues={initialValues} onSubmit={createNewPassword}>
      {({values, handleChange}) => (
        <Form>
          <Container className={classes.formContainer}>
            <Typography className={classes.displayMessage}>{formatMessage(messages.resetPasswordFor)} {username}</Typography>
            <TextField
              className={classes.textFields}
              error={passwordTooShort}
              helperText={passwordTooShort && formatMessage(messages.passwordTooShort)}
              label={formatMessage(messages.newPassword)}
              name="password"
              onChange={handleChange}
              onBlur={() => checkPasswordLength(values)}
              onFocus={() => setPasswordTooShort(false)}
              type={passwordVisibility1 ? 'text' : 'password'}
              InputProps={{
                endAdornment: (
                  <InputAdornment position='end'>
                    <IconButton
                      onClick={() => setPasswordVisibility1(!passwordVisibility1)}
                      tabIndex={-1}
                    >
                      {passwordVisibility1 ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
            <TextField
              className={classes.textFields}
              error={passwordsDoNotMatch && !passwordTooShort}
              helperText={passwordsDoNotMatch && !passwordTooShort && formatMessage(messages.passwordsDoNotMatch)}
              label={formatMessage(messages.repeatNewPassword)}
              name="repeatPassword"
              onBlur={() => checkPasswordsMatch(values)}
              onChange={handleChange}
              onFocus={() => setPasswordsDoNotMatch(false)}
              type={passwordVisibility2 ? 'text' : 'password'}
              InputProps={{
                endAdornment: (
                  <InputAdornment position='end'>
                    <IconButton
                      onClick={() => setPasswordVisibility2(!passwordVisibility2)}
                      tabIndex={-1}
                    >
                      {passwordVisibility2 ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </Container>
          <PopupModal
            className={classes.modalPlacement}
            message={modalMessage}
            open={!!modalMessage}
            removeErrorTitle={modalMessage === formatMessage(messages.resetPasswordComplete)}
            onClose={() => redirectToCorrectPage()}
          />
          <Button
            className={clsx(classes.majorButton, classes.marginTop30)}
            color='primary'
            type='submit'
            variant='contained'
          >
            {formatMessage(messages.login)}
          </Button>
        </Form>
      )}
    </Formik>
  )
}

export default withStyles(styles)(injectIntl(CreatePasswordForm))
